import { ref } from 'vue'

const STORAGE_KEY = 'sendmark-theme'
const DARK_CLASS = 'dark-mode'

const isDarkMode = ref(false)

export function initTheme() {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'dark') {
    isDarkMode.value = true
    document.documentElement.classList.add(DARK_CLASS)
  }
}

export function useTheme() {
  function toggleDarkMode() {
    isDarkMode.value = !isDarkMode.value
    if (isDarkMode.value) {
      document.documentElement.classList.add(DARK_CLASS)
      localStorage.setItem(STORAGE_KEY, 'dark')
    } else {
      document.documentElement.classList.remove(DARK_CLASS)
      localStorage.setItem(STORAGE_KEY, 'light')
    }
  }

  return {
    isDarkMode,
    toggleDarkMode
  }
}
